import request from '@/router/axios';

const getList = (current, size, params) => request({
  url: '/api/mcc-staff/staffExpensePercentage/list',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

const add = params => request({
  url: '/api/mcc-staff/staffExpensePercentage/save',
  method: 'post',
  data: params,
})

const detail = params => request({
  url: '/api/mcc-staff/staffExpensePercentage/detail',
  method: 'get',
  params: {
    ...params,
  },
})

const update = params => request({
  url: '/api/mcc-staff/staffExpensePercentage/update',
  method: 'post',
  data: params,
})

const remove = params => request({
  url: '/api/mcc-staff/staffExpensePercentage/remove',
  method: 'post',
  params: {
    id: params.id,
    type: params.type,
  },
})

export default {
  getList,
  add,
  detail,
  update,
  remove,
};
